import type { AvatarColor, AvatarIdentity } from "../types/teammates";

export type TeammateColor = { key: AvatarColor; fill: string; swatch: string; tag: string };

export const AVATAR_PALETTE: TeammateColor[] = [
  { key: "emerald", fill: "fill-emerald-600", swatch: "bg-emerald-600", tag: "border-emerald-100 bg-emerald-50 text-emerald-700" },
  { key: "orange", fill: "fill-orange-500", swatch: "bg-orange-500", tag: "border-orange-100 bg-orange-50 text-orange-700" },
  { key: "violet", fill: "fill-violet-600", swatch: "bg-violet-600", tag: "border-violet-100 bg-violet-50 text-violet-700" },
  { key: "rose", fill: "fill-rose-600", swatch: "bg-rose-600", tag: "border-rose-100 bg-rose-50 text-rose-700" },
  { key: "sky", fill: "fill-sky-600", swatch: "bg-sky-600", tag: "border-sky-100 bg-sky-50 text-sky-700" },
  { key: "yellow", fill: "fill-yellow-500", swatch: "bg-yellow-500", tag: "border-yellow-100 bg-yellow-50 text-yellow-700" },
  { key: "teal", fill: "fill-teal-600", swatch: "bg-teal-600", tag: "border-teal-100 bg-teal-50 text-teal-700" },
  { key: "fuchsia", fill: "fill-fuchsia-600", swatch: "bg-fuchsia-600", tag: "border-fuchsia-100 bg-fuchsia-50 text-fuchsia-700" },
];

export function hashText(text: string): number {
  const key = text.toLowerCase();
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  return hash;
}

export function teammateColor(teammate: { team_name: string | null; name: string }): TeammateColor {
  return AVATAR_PALETTE[hashText(teammate.team_name || teammate.name) % AVATAR_PALETTE.length];
}

export function avatarColor(teammate: AvatarIdentity): TeammateColor {
  return AVATAR_PALETTE.find((color) => color.key === teammate.appearance?.color) ?? teammateColor(teammate);
}
